"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const videoDevicesService = {
  getvideoDevicesIngetrations: function (options) {
    return api.get("/VideoDevices/Integrations", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  createVideoDevice: function (options) {
    return api.post("/VideoDevices", options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteVideoDevice: function (options) {
    return api.delete("/VideoDevices/" + options.id, WithToken.headersToken({}, configuration.cookieName));
  },
};

export default videoDevicesService;
